/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

const resolvePassportCopy = (copy, skus = {}, overrides = {}) => {
    const values = {
        defaultIntroPrice: skus.default_introductory_price,
        salePrice: skus.default_introductory_price,
        renewalPrice: skus.default_renewal_price,
    };
    Object.keys(skus).forEach((key) => {
        values[key] = skus[key];
        values[key.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase())] = skus[key];
    });
    Object.assign(values, overrides);

    return (copy || '').replace(/\{\{\s*([^{}]+?)\s*\}\}/g, (match, key) => (
        Object.prototype.hasOwnProperty.call(values, key) && values[key] !== null && values[key] !== undefined ? values[key] : match
    ));
};

export default resolvePassportCopy;
